const contractTypes = [
  { value: "fulltime", name: "Vollzeit" },
  { value: "parttime", name: "Teilzeit" },
  { value: "workingstudent", name: "Werkstudent" },
  { value: "internship", name: "Praktikum" },
  { value: "minijob", name: "Minijob" },
  { value: "prolonging", name: "Vertragsverlängerung" },
  { value: "shortterm", name: "Kurzfristige Beschäftigung" },
  { value: "termination", name: "Kündigung" },
  { value: "adjustment-hours", name: "Stundenanpassung" },
  { value: "adjustment-qualification", name: "Qualifikationsanpassung" },
  { value: "adjustment-tariff", name: "Tarifanpassung" }
];
export {
  contractTypes as c
};
//# sourceMappingURL=contractTypes.js.map
